var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-blob-json-csv',{staticClass:"btn btn-sm btn-secondary",attrs:{"tag-name":"div","file-type":"csv","file-name":_vm.fileName,"title":"Download","data":_vm.data},on:{"success":_vm.handleSuccess,"error":_vm.handleError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }